import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, X } from "lucide-react";

const CTX = [["kpi", "Goal KPI name"], ["target", "Goal value"], ["current", "MTD result for the goal"]];

const srcValue = (s) => (s.type === "raw" ? `raw:${s.column}` : s.type === "refill" ? `refill:${s.n}` : `ctx:${s.key}`);
const parseSrc = (v) => {
  const [t, ...rest] = v.split(":");
  const x = rest.join(":");
  return t === "raw" ? { type: "raw", column: x } : t === "refill" ? { type: "refill", n: Number(x) } : { type: "ctx", key: x };
};

export const EmailColumnRow = ({ col, idx, kind, columns, onChange, onMove, onRemove, testid }) => {
  const set = (patch) => onChange({ ...col, ...patch });
  const value = srcValue(col.source);
  const known = columns.includes(col.source.column);
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <Input className="h-8 text-xs w-48" value={col.label} onChange={(e) => set({ label: e.target.value })} data-testid={`${testid}-label`} />
      <select className="h-8 text-xs border border-slate-200 rounded-md px-1 flex-1 min-w-0 bg-white" value={value}
        onChange={(e) => set({ source: parseSrc(e.target.value) })} data-testid={`${testid}-source`}>
        <optgroup label="Special">
          {[2, 3, 4, 5, 6, 7].map((n) => <option key={n} value={`refill:${n}`}>{n}MR refill needed (vs Store Goals quota)</option>)}
          {kind === "goal" && CTX.map(([k, l]) => <option key={k} value={`ctx:${k}`}>{l}</option>)}
        </optgroup>
        <optgroup label="DLAR columns">
          {col.source.type === "raw" && !known && <option value={value}>{col.source.column} (not in latest DLAR)</option>}
          {columns.map((c) => <option key={c} value={`raw:${c}`}>{c}</option>)}
        </optgroup>
      </select>
      <select className="h-8 text-xs border border-slate-200 rounded-md px-1 w-24 bg-white" value={col.format}
        onChange={(e) => set({ format: e.target.value })} data-testid={`${testid}-format`}>
        <option value="number">Number</option><option value="percent">Percent</option><option value="text">Text</option>
      </select>
      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => onMove(idx, -1)} data-testid={`${testid}-up`}><ArrowUp className="w-3.5 h-3.5" /></Button>
      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => onMove(idx, 1)} data-testid={`${testid}-down`}><ArrowDown className="w-3.5 h-3.5" /></Button>
      <Button size="icon" variant="ghost" className="h-7 w-7 text-red-500" onClick={() => onRemove(idx)} data-testid={`${testid}-remove`}><X className="w-3.5 h-3.5" /></Button>
    </div>
  );
};
